import { AlertTriangle, ShieldAlert, TrendingUp } from 'lucide-react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, BarChart, Bar } from 'recharts';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../Components/Table';
import { ChartContainer } from '../Components/ChartContainer';
import { alertsData, declineTrendData, mccRiskData, paymentStatusData, failureReasons } from '../Data/mockData';

export default function Risk() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
      
      {/* Alert Summary Cards */}
      <div>
        <h2 style={{ fontSize: 18, fontWeight: 600, color: '#111827', marginBottom: 16 }}>
          Risk & Compliance Alerts
        </h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16 }}>
          
          {/* High Priority */}
          <div style={{ backgroundColor: '#fee2e2', border: '2px solid #fecaca', borderRadius: 8, padding: 16 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12 }}>
              <div style={{ width: 40, height: 40, backgroundColor: '#ef4444', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <ShieldAlert style={{ width: 20, height: 20, color: '#ffffff' }} />
              </div>
              <div>
                <div style={{ fontSize: 12, color: '#4b5563' }}>High Priority Alerts</div>
                <div style={{ fontSize: 24, fontWeight: 700, color: '#b91c1c' }}>5</div>
              </div>
            </div>
            <div style={{ fontSize: 12, color: '#4b5563' }}>Requires immediate attention</div>
          </div>

          {/* Medium Priority */}
          <div style={{ backgroundColor: '#ffedd5', border: '2px solid #fdba74', borderRadius: 8, padding: 16 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12 }}>
              <div style={{ width: 40, height: 40, backgroundColor: '#f97316', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <AlertTriangle style={{ width: 20, height: 20, color: '#ffffff' }} />
              </div>
              <div>
                <div style={{ fontSize: 12, color: '#4b5563' }}>Medium Priority Alerts</div>
                <div style={{ fontSize: 24, fontWeight: 700, color: '#ea580c' }}>12</div>
              </div>
            </div>
            <div style={{ fontSize: 12, color: '#4b5563' }}>Review within 48 hours</div>
          </div>

          {/* Low Priority */}
          <div style={{ backgroundColor: '#fef3c7', border: '2px solid #fde68a', borderRadius: 8, padding: 16 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12 }}>
              <div style={{ width: 40, height: 40, backgroundColor: '#facc15', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <TrendingUp style={{ width: 20, height: 20, color: '#ffffff' }} />
              </div>
              <div>
                <div style={{ fontSize: 12, color: '#4b5563' }}>Low Priority Alerts</div>
                <div style={{ fontSize: 24, fontWeight: 700, color: '#ca8a04' }}>8</div>
              </div>
            </div>
            <div style={{ fontSize: 12, color: '#4b5563' }}>Monitor and review</div>
          </div>
        </div>
      </div>



      <div className='mt3'>
                <h2
                    style={{
                        fontSize: 20,
                        color: '#0F172A',
                        marginBottom: 16
                    }}
                >
                    Payment Status
                </h2>

                <div
                    style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(2, 1fr)',
                        gap: 16
                    }}
                >
                    <ChartContainer title="Payment Status Breakdown">
                        <ResponsiveContainer width="100%" height={300}>
                            <BarChart data={paymentStatusData}>
                                <CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" />
                                <XAxis dataKey="status" tick={{ fontSize: 12 }} />
                                <YAxis tick={{ fontSize: 12 }} />
                                <Tooltip />
                                <Bar
                                    dataKey="count"
                                    fill="#2563EB"
                                    radius={[4, 4, 0, 0]}
                                />
                            </BarChart>
                        </ResponsiveContainer>
                    </ChartContainer>

                    <ChartContainer title="Failure Reasons">
                        <ResponsiveContainer width="100%" height={300}>
                            <BarChart data={failureReasons} layout="vertical">
                                <CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" />
                                <XAxis type="number" tick={{ fontSize: 12 }} />
                                <YAxis
                                    dataKey="reason"
                                    type="category"
                                    tick={{ fontSize: 12 }}
                                    width={120}
                                />
                                <Tooltip />
                                <Bar
                                    dataKey="count"
                                    fill="#DC2626"
                                    radius={[0, 4, 4, 0]}
                                />
                            </BarChart>
                        </ResponsiveContainer>
                    </ChartContainer>
                </div>
            </div>

      {/* Risk Trends */}
      <div style={{ backgroundColor: '#ffffff', borderRadius: 8, border: '1px solid #e5e7eb', padding: 24 }}>
        <h2 style={{ fontSize: 18, fontWeight: 600, color: '#111827', marginBottom: 16 }}>Decline & Fraud Trends</h2>
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={declineTrendData}>
            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
            <XAxis dataKey="month" tick={{ fontSize: 12 }} />
            <YAxis tick={{ fontSize: 12 }} />
            <Tooltip />
            <Line type="monotone" dataKey="declines" stroke="#f59e0b" strokeWidth={2} name="Total Declines" />
            <Line type="monotone" dataKey="fraudAttempts" stroke="#ef4444" strokeWidth={2} name="Fraud Attempts" />
          </LineChart>
        </ResponsiveContainer>
      </div>

            {/* Alerts Table */}
            <div style={{ backgroundColor: '#ffffff', borderRadius: 8, border: '1px solid #e5e7eb' }}>
        <div style={{ padding: 24, borderBottom: '1px solid #e5e7eb' }}>
          <h2 style={{ fontSize: 18, fontWeight: 600, color: '#111827' }}>Active Compliance Alerts</h2>
        </div>
        <div style={{ overflowX: 'auto' }}>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Alert Type</TableHead>
                <TableHead>Corporate</TableHead>
                <TableHead>Severity</TableHead>
                <TableHead>Count</TableHead>
                <TableHead>Due Date</TableHead>
                <TableHead>Action</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {alertsData.map((row) => {
                const bgColor =
                  row.severity === 'high' ? '#fee2e2' :
                  row.severity === 'medium' ? '#ffedd5' : '#fef3c7';
                const textColor =
                  row.severity === 'high' ? '#b91c1c' :
                  row.severity === 'medium' ? '#ea580c' : '#ca8a04';

                return (
                  <TableRow key={row.id} style={{ backgroundColor: bgColor }}>
                    <TableCell style={{ fontWeight: 500 }}>{row.type}</TableCell>
                    <TableCell>{row.corporate}</TableCell>
                    <TableCell>
                      <span style={{
                        display: 'inline-flex',
                        padding: '2px 8px',
                        fontSize: 12,
                        fontWeight: 500,
                        borderRadius: 9999,
                        color: textColor,
                        backgroundColor: bgColor,
                      }}>
                        {row.severity.toUpperCase()}
                      </span>
                    </TableCell>
                    <TableCell>{row.count}</TableCell>
                    <TableCell>{row.dueDate}</TableCell>
                    <TableCell>
                      <button style={{
                        fontSize: 12,
                        color: '#2563eb',
                        fontWeight: 500,
                        cursor: 'pointer',
                        background: 'none',
                        border: 'none',
                        padding: 0
                      }}>
                        Review
                      </button>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </div>
      </div>

      {/* MCC Risk Heatmap */}
      <div style={{ backgroundColor: '#ffffff', borderRadius: 8, border: '1px solid #e5e7eb' }}>
        <div style={{ padding: 24, borderBottom: '1px solid #e5e7eb' }}>
          <h2 style={{ fontSize: 18, fontWeight: 600, color: '#111827' }}>MCC Risk Analysis</h2>
        </div>
        <div style={{ overflowX: 'auto' }}>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>MCC Code</TableHead>
                <TableHead>Category</TableHead>
                <TableHead>Total Transactions</TableHead>
                <TableHead>Declines</TableHead>
                <TableHead>Risk Score (%)</TableHead>
                <TableHead>Risk Level</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {mccRiskData.map((row, index) => {
                const progressColor =
                  row.riskScore > 10 ? '#dc2626' :
                  row.riskScore > 5 ? '#f97316' : '#16a34a';
                const badgeColor =
                  row.riskScore > 10 ? '#fee2e2' :
                  row.riskScore > 5 ? '#ffedd5' : '#d1fae5';
                const badgeTextColor =
                  row.riskScore > 10 ? '#b91c1c' :
                  row.riskScore > 5 ? '#c2410c' : '#166534';

                return (
                  <TableRow key={index}>
                    <TableCell style={{ fontWeight: 500 }}>{row.mcc}</TableCell>
                    <TableCell>{row.category}</TableCell>
                    <TableCell>{row.transactions.toLocaleString()}</TableCell>
                    <TableCell>{row.declines}</TableCell>
                    <TableCell>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <div style={{ flex: 1, backgroundColor: '#e5e7eb', borderRadius: 9999, height: 8, maxWidth: 100 }}>
                          <div style={{ width: `${Math.min(row.riskScore * 4, 100)}%`, backgroundColor: progressColor, height: '100%', borderRadius: 9999 }} />
                        </div>
                        <span style={{ fontWeight: 600 }}>{row.riskScore}%</span>
                      </div>
                    </TableCell>
                    <TableCell>
                      <span style={{
                        display: 'inline-flex',
                        padding: '2px 8px',
                        fontSize: 12,
                        fontWeight: 500,
                        borderRadius: 9999,
                        color: badgeTextColor,
                        backgroundColor: badgeColor,
                      }}>
                        {row.riskScore > 10 ? 'High' : row.riskScore > 5 ? 'Medium' : 'Low'}
                      </span>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </div>
      </div>
    </div>
  );
}
